import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ThreeColumRow from "../../components/ThreeColumRow";
import TwoColumRow from "../../components/TwoColumRow";
import { useParams } from "react-router-dom";
import Loading from "../Loading";
import { useAntecedent } from "../../customHooks/queries/useAntecedent";
import {
  getVisitas,
  getAllVisitas,
} from "../../redux/features/visitasSlice";
import { latestValidMeasure } from "../../utils/visitaMeasures";

function HealthInfomationView() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { data: antecedent, isLoading } = useAntecedent(id);
  const visitasData = useSelector(getAllVisitas);

  useEffect(() => {
    if (id) dispatch(getVisitas(id));
  }, [id, dispatch]);

  // Muestra el último peso/altura registrado en una visita (refleja al toque tras editar una visita,
  // sin recargar). Si no hay visita con ese dato, cae al valor guardado en antecedentes.
  const altura =
    latestValidMeasure(visitasData, "altura") ?? antecedent?.altura;
  const peso = latestValidMeasure(visitasData, "peso") ?? antecedent?.peso;

  return (
    <div className="flex flex-col justify-between gap-4">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="w-full flex flex-col  gap-3">
          <ThreeColumRow>
            <p className=" text-xs font-light">
              <span className="text-xs block font-medium">Tipo Sangre:</span>{" "}
              {antecedent?.sangre}{" "}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Altura:</span>{" "}
              {altura}
              {" cm"}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Peso:</span>{" "}
              {peso}
              {" kg"}
            </p>
          </ThreeColumRow>
          <div>
            <p className="text-xs font-light">
              <span className="text-xs font-medium">Alergias:</span>{" "}
              {antecedent?.alergias
                ? antecedent?.alergias_description?.replace(/\|/g, ", ") ?? "NO"
                : "NO"}
            </p>
          </div>
          {/* <TwoColumRow>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">notas legado:</span>{" "}
              {antecedent?.notas_legado}{" "}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Donante:</span>
              {antecedent?.donante ? "SI" : "NO"}
            </p>
          </TwoColumRow> */}
          {/* <ThreeColumRow>
           
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Fuma:</span>
              {antecedent?.fuma ? "SI" : "NO"}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Vape:</span>
              {antecedent?.vape ? "SI" : "NO"}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs block font-medium">Alcohol:</span>
              {antecedent?.alcohol ? "SI" : "NO"}
            </p>
          </ThreeColumRow> */}
          <div>
            <p className="text-xs font-light">
              <span className="text-xs font-medium">Medicacion en uso:</span>{" "}
              {antecedent?.medicacion
                ? antecedent?.medicacion_description?.replace(/\|/g, ", ") ??
                  "NO"
                : "NO"}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs font-medium">
                Historial familiar de enfermedades:
              </span>{" "}
              {antecedent?.enfermedades
                ? antecedent?.enfermedades_description?.replace(/\|/g, ", ") ??
                  "NO"
                : "NO"}
            </p>
            <p className="text-xs font-light">
              <span className="text-xs font-medium">Datos Quirúrgicos:</span>{" "}
              {antecedent?.quirurgicos
                ? antecedent?.quirurgicos_description?.replace(/\|/g, ", ") ??
                  "NO"
                : "NO"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default HealthInfomationView;
